import React from 'react';
import { useState } from 'react';

export default function Verification() {
    return (
        <main>
        <header className="purchase-confirmation">
            <p className="shop-sustainably-confirmation">Thank you for shopping with Source!</p>
        </header>
        <footer>
        <div>
          <p>Source</p>
          <p>&copy; 2022 INFO442 Project</p>
        </div>
      </footer>
        </main>
    )
}